module.exports = __webpack_public_path__ + "img/collage.010a7ceb.jpg";